@if (data$ | async; as data) {
	<div class="container" [ngClass]="{ warning: data.showWarning }">
		@if (data.showWarning && icon != null) {
			<ion-icon name="{{ icon }}"></ion-icon>
		}
		@if (data.minutesSinceLastUpdate == null) {
			{{ "LAST_UPDATED__NEVER" | transloco }}
		}
		@if (data.minutesSinceLastUpdate === 0) {
			{{ "LAST_UPDATED__JUST_UPDATED" | transloco }}
		}
		@if (data.minutesSinceLastUpdate >= 1) {
			{{ data.minutesSinceLastUpdate }} {{ "LAST_UPDATED__MIN_AGO" | transloco }}
		}
	</div>
}
